import { useEffect } from 'react';

/**
 * Précharge uniquement les images critiques pour le LCP
 * Ne précharge PAS sur connexions lentes ou mode économie données
 */
export const CriticalImagePreloader: React.FC = () => {
  useEffect(() => {
    // Vérifier la qualité de connexion
    if ('connection' in navigator) {
      const connection = (navigator as any).connection;
      // Ne pas précharger sur connexion lente ou mode économie
      if (
        connection?.saveData ||
        connection?.effectiveType === 'slow-2g' ||
        connection?.effectiveType === '2g' ||
        connection?.effectiveType === '3g'
      ) {
        console.log('⚡ Skipping preload - slow connection or data saver enabled');
        return;
      }
    }

    // Uniquement le logo principal pour le LCP
    const criticalImages = [
      {
        href: '/lovable-uploads/c001cf99-e1b1-4db0-a040-dca2b3cc49a6.png',
        as: 'image',
        type: 'image/png',
        fetchPriority: 'high'
      }
    ];

    criticalImages.forEach(({ href, as, type, fetchPriority }) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = as;
      link.href = href;
      if (type) link.type = type;
      link.setAttribute('fetchpriority', fetchPriority);
      
      // Vérifier que le link n'existe pas déjà
      const existingLink = document.querySelector(`link[href="${href}"]`);
      if (!existingLink) {
        document.head.appendChild(link);
      }
    });

    return () => {
      // Cleanup si nécessaire
      criticalImages.forEach(({ href }) => {
        const link = document.querySelector(`link[href="${href}"]`);
        if (link && link.getAttribute('rel') === 'preload') {
          link.remove();
        }
      });
    };
  }, []);

  return null;
};
